import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTIENER LISTA DE CLIENTES
export const getTerminos = async () => {
    const result = await PrivateInterceptor('Terminos', 'GET')
    return result;
};

export const getTerminosPago = async () => {
    const result = await PrivateInterceptor('Terminos/PayTerm', 'GET')
    return result;
};
